<template>
    <div id="pt090" class="pt090" v-if="getLengthObj(osiraseList) > 0" v-cloak>
        <div class="itemTitle">
            <h2>{{$t('pt090.labels.title')}}</h2>
        </div>
        <dl class="infoList" >
            <template v-for="(item,index) in osiraseList">
                <dt class="infoDate" :key="index+'_0'">
                    {{item.DISP_YMD_FROM_D}}
                </dt>
                <!--メーカー店舗タイトル利用フラグ-->
                <dt class="infoMaker" :key="index+'_2'" v-if="storeTitleFlg == 1">
                    <!--全体向け(メーカーより)-->
                    <template v-if="item.EC_OPEN_FLG == 0">
                        {{$t('pt090.labels.comp')}}
                    </template>
                    <!--限定向け(店舗より)-->
                    <template v-else-if="item.EC_OPEN_FLG == 1">
                        {{$t('pt090.labels.store')}}
                    </template>
                </dt>
                <dd class="infoTitle" :key="index+'_1'">
                    <a @click="openDetail(item.SEQ)" class="detailInfo_title_a">
                        {{item.TITTLE}}
                    </a>
                </dd>
            </template>
        </dl>
        <p-t090-detail 
            v-if="showPT090DetailFlg" :request="pt090Detail" @closed="showPT090DetailFlg = false">
        </p-t090-detail>
    </div>
</template>

<script>
/* 
* Import libs and componnents
*/
import PT090Detail from './PT090InformationPartDetail';
import common from "assets/js/common";
import axios from "assets/js/request";

export default {
    /* 
    * Name of component
    */
    name: "PT090InformationParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /* 
    * Declare components
    */
    components: {
        PT090Detail
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            showPT090DetailFlg: false,
            pt090Detail: {
                seq:null
            },
            osiraseList: [
            ],
            pt090Request:{},
            storeTitleFlg: 0
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        if (_this.ptInitData){
            _this.osiraseList = _this.ptInitData.osiraseList;
            _this.storeTitleFlg = _this.ptInitData.storeTitleFlg;
        }else{
            axios
            .post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.PT090 + _this.$UrlConstants.DO_INIT, _this.pt090Request)
            .then(function(response) {
                _this.osiraseList = response.data.osiraseList;
                _this.storeTitleFlg = response.data.storeTitleFlg;
            })
            .catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    /* 
    * Methods
    */
    methods: {
        openDetail: function(seq) {
            this.pt090Detail.seq =seq;
            this.showPT090DetailFlg = true;
        },
        /*
        * Get length obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
    }
}
</script>
